export function projectReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_PROJECT":            
        case "UPDATE_PROJECT":
            let list = Object.assign({}, state);
            list[payload.project_id] = payload
        
            return list
            
        case "GET_PROJECTS":

            return payload
            
        default:
            return state;
    }
    
}